import Image from "next/image";
import React from "react";

export default function BenefitsCardImage({ item }) {
  return (
    <figure className="h-12 w-12 border rounded-md overflow-hidden">
      <Image
        height={500}
        width={500}
        src={process.env.NEXT_PUBLIC_SPACES_URL + item?.icon}
        alt="banner"
        className=" p-3 hover:mix-blend-screen bg-white object-cover"
      />
    </figure>
  );
}
